module.exports = __webpack_public_path__ + "static/media/TATACONSUM_F1.721594c7.txt";